<template>
    <b-card class="block__objectiveListProduction">

      <header>
        <p class="title">
          <PuSkeleton :loading="isLoading" :count="1" width='120px'>
            {{ name }}
          </PuSkeleton>
        </p>
      </header>

      <b-list-group>
        <b-list-group-item v-for="(list,index) of lists" :key="index" :class="index !== lists.length - 1 ? 'border-bottom' : ''">
          <div class="entete">
            <PuSkeleton :loading="isLoading" :count="1" width='160px'>
              <div class="title" style="max-width: 800px;">
                  {{list.proCriteria.name}}
              </div>
            </PuSkeleton>
            <PuSkeleton :loading="isLoading" :count="1" width='20px'>
              <div class="number">
                Prime {{list.proCriteria.prime}}
              </div>
            </PuSkeleton>
          </div>
          <div class="label">
            <div class="left" v-if="!list.proCriteria.variableObjective">
              <b-form-input v-model="list.objective" :readonly="readonly"
              ></b-form-input>
            </div>
            <div class="left" v-else>
              {{ list.proCriteria.variableObjectiveText }}
            </div>
          </div>

          <div class="label" v-if="list.valueN1 && !list.proCriteria.chooseAgent">
            <div class="left">
              <PuSkeleton :loading="isLoading" :count="1" width='160px'>
                <div class="n1">
                  n-1 : {{list.valueN1}}
                </div>
              </PuSkeleton>
            </div>
          </div>

          <div class="label" v-if="list.proCriteria.chooseAgent">
            <PuSkeleton :loading="isLoading" :count="1" width='160px'>
              <div style="max-width: 800px; margin-top: 15px">
                Choisir {{list.proCriteria.numberAgents}} agents
              </div>
            </PuSkeleton>
          </div>
          <div class="label" v-for="n in list.proCriteria.numberAgents" :key="`${n}-${list.id}`">
            <div class="select__wrapper">
              <font-awesome-icon :icon="['far', 'chevron-down']" />
              <b-form-select :disabled="readonly" v-if="list.agents[n-1]" v-model="list.agents[n-1].id" :options="agentsDropdowns" class="select"></b-form-select>
              <b-form-select :disabled="readonly" v-if="!list.agents[n-1]" v-on:change="selectAgent($event,list, n-1)" :options="agentsDropdowns" class="select">
              </b-form-select>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>

    </b-card>
</template>


<script>

export default {
name:"wrapperPRODraft",
  props:{
    lists:{
      default: () => {
        return []
        }
      },
    agents:{
      default: () => {
        return []
        }
      },
    name : {
      default: null
    },
    readonly : {
      default: false
    },
    isLoad:{
      default: true
    },
    userProUserProObjectivesIndex:{
      default: null
    }
  },
  data(){
    return {
      isLoading:true,
      datalists: {
        },
      agentsDropdowns: []
    }
  },
  created(){
    this.isLoading = this.isLoad;
    this.datalists = this.lists;
    console.log('lists', this.lists);
    this.agentsDropdowns = this.agents;
  },
  methods:{
    isPostive(value,qualificatifValue = 0, isReverse = false){
      const percent = Math.round((value * 100) / qualificatifValue);
      if (isReverse){
        return 85 > percent ?  'green' : 'yellow';
      }
      return 85 <= percent ?  'green' : 'yellow';
    },
    getPercent(value, objective){
      return Math.round((value * 100) / objective).toLocaleString();
    },
    selectAgent(event, userProObjectives, index){
      userProObjectives.agents[index] = event;
    }
  },
  watch : {
    'isLoad' : function (){
      this.datalists = this.lists;
      this.isLoading = this.isLoad;
    },
  },
}
</script>
